/** One grey, drawn from each company's own mark; heights evened by eye. */
const CUSTOMERS = [
  { src: "/logos/accent-productions.png", alt: "Accent Productions" },
  { src: "/logos/the-rock-factory.png", alt: "The Rock Factory" },
  { src: "/logos/triac.png", alt: "Triac Light & Sound" },
];

export function Logos() {
  return (
    <section className="logos">
      <p>Taking hundreds of calls and texts every month for hire companies in New Zealand</p>
      <div className="row">
        {CUSTOMERS.map((c) => (
          <img key={c.src} src={c.src} alt={c.alt} />
        ))}
      </div>
    </section>
  );
}
